/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import CoverLayout from "layouts/authentication/components/CoverLayout";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Auto from "components/AutoComplete/AutoComplete";
import CustomText from "components/customtext/customtext";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appConstants } from "utils/appConstants";
import { getShippingCompany, newCustomerSignUp } from "utils/authApi";
import {
  generateDataList,
  handleStreetAddress,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import validator from "validator";
import bgImage from "../../assets/images/download.jpg";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let mandateFlag = false;

function SignUpCover({ ...props }) {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [fNameErr, setfNameErr] = useState(false);
  const [lNameErr, setlNameErr] = useState(false);
  const [phoneNumberErr, setPhoneNumberErr] = useState(false);
  const [emailAddressErrMsg, setEmailAddressErrMsg] = useState("");
  const [passwordErr, setPasswordErr] = useState(false);
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [checked, setChecked] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [bussinessName, setBussinessName] = useState([]);
  const [bussinessIDErr, setBussinessIDErr] = useState(false);
  const [businessNameErr, setBusinessNameErr] = useState(false);
  const [shipmentCompanyErr, setShipmentCompanyErr] = useState(false);
  const [accountErrr, setAccountErr] = useState(false);
  const [zipErr, setZipErr] = useState(false);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [values1, setValues1] = React.useState({
    firstName: "",
    lastName: "",
    countryCode: "",
    phoneNumber: "+61",
    onlyPhoneNumber: "+61",
    emailAddress: "",
    loginURL: appConstants.loginURL,
    password: "",
    businessUserID: "",
    confirmPassword: "",
    userPassword: "",
    mobileNumberExist: true,
    referralCode: "",
    streetAddress: "",
    city: "",
    stateId: "",
    countryId: "",
    customerType: "Individual",
    businessID: "",
    businessName: "",
    zipCode: "",
    paymentType: "Self-Payment",
    customerLocationLatitude: "",
    customerLocationLongitude: "",
  });
  let countryData = useSelector(
    (state) => state.countryState.countryStateMenu.country
  );
  let stateData = useSelector(
    (state) => state.countryState.countryStateMenu.state
  );

  const saveSignupData = () => {
    sessionStorage.setItem("SIGN_CUSUP_TEMP_DATA", JSON.stringify(values1));
  };
  const handleChange1 = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues1({ ...values1, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues1({ ...values1, [name]: event.target.value });
    }
  };
  const clearErrState = () => {
    setShipmentCompanyErr(false);
    setBusinessNameErr(false);
    setBussinessIDErr(false);
    setfNameErr(false);
    setlNameErr(false);
    setStreetAddressErr(false);
    setAccountErr(false);
  };

  const signup = async () => {
    try {
      clearErrState();
      mandateFlag = false;
      mandateFlag =
        validateField(values1.businessUserID, setShipmentCompanyErr) ||
        mandateFlag;
      if (values1.customerType === "Business") {
        mandateFlag =
          validateField(values1.businessName, setBusinessNameErr) ||
          mandateFlag;
        mandateFlag =
          validateField(values1.businessID, setBussinessIDErr) || mandateFlag;
      }
      mandateFlag =
        validateField(values1.firstName, setfNameErr) || mandateFlag;
      mandateFlag = validateField(values1.lastName, setlNameErr) || mandateFlag;
      mandateFlag =
        validateField(values1.streetAddress, setStreetAddressErr) ||
        mandateFlag;
      if (values1.emailAddress.toString().trim() === "") {
        setEmailAddressErrMsg("Email Address can't be blank");
        mandateFlag = true;
      } else if (!validator.isEmail(values1.emailAddress)) {
        setEmailAddressErrMsg("Enter a valid Email Address");
        mandateFlag = true;
      } else setEmailAddressErrMsg("");
      if (values1.onlyPhoneNumber.toString().trim() !== "") {
        if (values1.phoneNumber.toString().trim().length < 4) {
          console.log("a");
          setPhoneNumberErr("Mobile Number can't be blank");
          mandateFlag = true;
        } else if (values1.phoneNumber.toString().trim().length < 9) {
          setPhoneNumberErr("Please enter valid Mobile Number");
          mandateFlag = true;
        } else {
          setPhoneNumberErr(false);
        }
      } else if (values1.onlyPhoneNumber.toString().trim().length < 2) {
        setPhoneNumberErr("Mobile Number can't be blank");
      } else if (values1.onlyPhoneNumber.toString().trim().length < 9) {
        setPhoneNumberErr("Please enter valid Mobile Number");
      } else {
        setPhoneNumberErr(false);
      }

      if (values1.paymentType === "Account Payment") {
        mandateFlag =
          validateField(values1.accountNumber, setAccountErr) || mandateFlag;
      }
      if (values1.password.toString().trim() === "") {
        setPasswordErr("New Password can't be blank");
        mandateFlag = true;
      } else if (values1.password.toString().trim().length < 8) {
        setPasswordErr("New Password should contain at least 8 characters");
        mandateFlag = true;
      } else setPasswordErr("");
      if (values1.confirmPassword.toString().trim() === "") {
        setConfirmPasswordErr("Confirm Password can't be blank");
        mandateFlag = true;
      } else if (
        values1.password.toString().trim() !==
        values1.confirmPassword.toString().trim()
      ) {
        setConfirmPasswordErr(
          "Confirm Password should be same as New Password"
        );
        mandateFlag = true;
      } else setConfirmPasswordErr("");
      if (mandateFlag) {
        return;
      }
      if (checked !== true) {
        showResMsg(genericMessage.acceptConditions, 2000, false);
        mandateFlag = true;
        return;
      }
      values1.userPassword = values1.confirmPassword;
      newCustomerSignUp(
        values1,
        (data) => {
          sessionStorage.setItem("SIGN_UP_DETAILS", JSON.stringify(values1));
          let fetchedUser = [];
          if (data.Result_Output.length > 0) {
            fetchedUser = data.Result_Output;
          }
          if (data.Result_Status) {
            navigate("/otp");
          } else {
            showResMsg(data.Result_Message, 2000, data.Result_Status);
          }
        },
        dispatch
      );
    } catch (error) {
      console.log("Catch in  signup user=", error);
    }
  };

  useEffect(() => {
    (async () => {
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
      fetchShippingCompany();
    })();
    if (
      sessionStorage.getItem("SIGN_CUSUP_TEMP_DATA") !== "" &&
      sessionStorage.getItem("SIGN_CUSUP_TEMP_DATA") !== null
    ) {
      setValues1(JSON.parse(sessionStorage.getItem("SIGN_CUSUP_TEMP_DATA")));
      sessionStorage.removeItem("SIGN_CUSUP_TEMP_DATA");
    }
  }, []);

  let fetchShippingCompany = async () => {
    getShippingCompany(values1, (data) => {
      if (data.Result_Output.length > 0) {
        setBussinessName(data.Result_Output);
      }
    });
  };

  const setPhoneValues = (phone, country) => {
    values1.onlyPhoneNumber = phone.slice(country.dialCode.length);
    console.log("phone", phone.slice(country.dialCode.length));
    values1.phoneNumber = phone.slice(country.dialCode.length);
    values1.phoneNumber = phone;
    values1.countryCode = "+" + country.dialCode;
  };

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues1((prevValues) => ({
        ...prevValues,
        streetAddress: "",
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
      }));
    } else {
      setValues1((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  };

  let bussinessList =
    bussinessName.length > 0 &&
    bussinessName.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.companyName},{item.companyCity}
        </MenuItem>
      );
    }, this);

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Invoice & Recover (Customer Signup)
          </MDTypography>
          {/* <MDTypography display="block" variant="button" color="white" my={1}>
            Enter your email and password to register
          </MDTypography> */}
        </MDBox>
        <Grid container columnSpacing={4} px={2}>
          <Grid item xs={12} lg={12}>
            <CustomText type="b" size={15}>
              Business
            </CustomText>
          </Grid>
          <Grid item lg={3} xs={12}>
            <FormControl
              fullWidth
              variant="standard"
              style={{ minHeight: "45.1px" }}
            >
              <InputLabel id="demo-simple-select-standard-label">
                Shipping Company
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ minHeight: "29.11px" }}
                label="Shipping Company"
                value={values1.businessUserID}
                onChange={handleChange1("businessUserID")}
              >
                {bussinessList}
              </Select>
              {shipmentCompanyErr ? (
                <span style={errMsg}>Shipping Company can't be blank</span>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
          <Grid item lg={3} xs={12}>
            <FormControl
              fullWidth
              variant="standard"
              sx={{ m: 1, mt: 0, ml: 0 }}
              style={{ minHeight: "45.1px" }}
            >
              <InputLabel id="demo-simple-select-standard-label">
                Customer Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ minHeight: "29.11px" }}
                label="Customer Type"
                value={values1.customerType}
                onChange={handleChange1("customerType")}
              >
                <MenuItem value="Individual">Individual</MenuItem>
                <MenuItem value="Business">Business</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="Business Name"
                variant="standard"
                fullWidth
                inputProps={{
                  pattern: "[A-Za-z ]*",
                  maxLength: 30,
                }}
                disabled={values1.customerType === "Individual" ? true : false}
                value={values1.businessName}
                onChange={handleChange1("businessName")}
              />
              {businessNameErr ? (
                <span style={errMsg}>Business Name can't be blank</span>
              ) : (
                ""
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="ABN"
                variant="standard"
                fullWidth
                inputProps={{
                  pattern: '[0-9!@#$%^&*-_+=,.<>?;:"]*',
                  maxLength: 14,
                }}
                disabled={values1.customerType === "Individual" ? true : false}
                value={values1.businessID}
                onChange={handleChange1("businessID")}
              />
              {bussinessIDErr ? (
                <span style={errMsg}>Bussiness ID can't be blank</span>
              ) : (
                ""
              )}
            </MDBox>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={12} px={2.5}>
          <CustomText type="b" size={15}>
            Personal Details
          </CustomText>
        </Grid>
        <Grid container rowGap={2} px={3} columnSpacing={2}>
          <Grid item xs={12} lg={3} pt={-2}>
            <MDBox>
              <MDInput
                type="text"
                label="First Name"
                variant="standard"
                fullWidth
                inputProps={{
                  pattern: "[A-Za-z ]*",
                  maxLength: 30,
                }}
                onChange={handleChange1("firstName")}
              />
              {fNameErr ? (
                <span style={errMsg}>First Name can't be blank</span>
              ) : (
                ""
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="Last Name"
                variant="standard"
                fullWidth
                inputProps={{
                  pattern: "[A-Za-z ]*",
                  maxLength: 30,
                }}
                value={values1.lastName}
                onChange={handleChange1("lastName")}
              />
              {lNameErr ? (
                <span style={errMsg}>Last Name can't be blank</span>
              ) : (
                ""
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDInput
              type="text"
              label="Email Address"
              variant="standard"
              fullWidth
              inputProps={{
                maxLength: 50,
              }}
              value={values1.emailAddress}
              onChange={handleChange1("emailAddress")}
            />
            {emailAddressErrMsg !== "" ? (
              <span style={errMsg}>{emailAddressErrMsg}</span>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} lg={3}>
            <MuiPhoneNumber
              defaultCountry={"au"}
              type="text"
              label="Mobile Number"
              variant="standard"
              fullWidth
              value={values1.phoneNumber}
              onChange={(phone, country) => setPhoneValues(phone, country)}
            />
            {phoneNumberErr ? <span style={errMsg}>{phoneNumberErr}</span> : ""}
          </Grid>
          {/* <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="Company Name"
                variant="standard"
                fullWidth
                value={values1.companyName}
                onChange={handleChange1("companyName")}

              />
              {lNameErr ? <span style={errMsg}>Last Name can't be blank</span> : ""}
            </MDBox>
          </Grid> */}
          <Grid item xs={12} lg={6} className="google">
            {/* <MDInput
                type="text"
                label="Street Address"
                variant="standard"
                fullWidth
              value={values1.companyStreetAddress}
              onChange={handleChange1("companyStreetAddress")}

              /> */}
            <Auto
              onChange={handleStreetOnChange}
              onPlaceSelected={(place, e) =>
                handleStreetAddress(
                  place,
                  e,
                  (data) => {
                    setValues1((prevValues) => ({
                      ...prevValues,
                      zipCode: data.zipCode,
                      city: data.city,
                      countryId: data.countryId,
                      stateId: data.stateId,
                      streetAddress: data.streetAddress,
                      customerLocationLatitude: data.locationLatitude,
                      customerLocationLongitude: data.locationLongitude,
                    }));
                  },
                  stateListRef,
                  countryListRef
                )
              }
              value={values1.streetAddress}
              standard="true"
              variant="standard"
            />
            {streetAddressErr ? (
              <span style={errMsg}>Street Address can't be blank</span>
            ) : (
              ""
            )}
            {/* <ReactGoogleAutocomplete
              className="GoogleInput1"
              placeholder="Street Address"
              id="standard-basic"
              apiKey={appConstants.googleAutoCommpleteKey}
              onChange={handleStreetOnChange}
              onPlaceSelected={(place, e) => handleStreetAddress(place, e)}
              options={{
                types: ["address"],
                componentRestrictions: { country: "au" },
              }
              }
              inputClassName="GoogleInput1" // Add a class name to the input element
              defaultValue={values1.streetAddress}
            /> */}
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="City"
                disabled
                variant="standard"
                fullWidth
                value={values1.city}
                onChange={handleChange1("city")}
              />
              {cityErr ? <span style={errMsg}>City can't be blank</span> : ""}
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="Zip Code"
                variant="standard"
                fullWidth
                disabled
                inputProps={{
                  pattern: "[0-9]*",
                  maxLength: 4,
                }}
                value={values1.zipCode}
                onChange={handleChange1("zipCode")}
              />
              {zipErr !== "" ? <span style={errMsg}>{zipErr}</span> : ""}
            </MDBox>
          </Grid>

          <Grid item xs={12} lg={3}>
            <FormControl
              fullWidth
              variant="standard"
              sx={{ m: 1, mt: 0, ml: 0 }}
              style={{ minHeight: "45.1px" }}
            >
              <InputLabel id="demo-simple-select-standard-label">
                Country
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ minHeight: "29.11px" }}
                label="Country"
                disabled
                value={values1.countryId}
                onChange={(e) =>
                  setValues1({ ...values1, countryId: e.target.value })
                }
              >
                {country}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}>
            <FormControl
              fullWidth
              variant="standard"
              sx={{ m: 1, mt: 0, ml: 0 }}
              style={{ minHeight: "45.1px" }}
            >
              <InputLabel id="demo-simple-select-standard-label">
                State
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="State"
                disabled
                style={{ minHeight: "29.11px" }}
                value={values1.stateId}
                onChange={(e) =>
                  setValues1({ ...values1, stateId: e.target.value })
                }
              >
                {state}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} lg={3}>
            <FormControl
              fullWidth
              variant="standard"
              sx={{ m: 1, mt: 0, ml: 0 }}
              style={{ minHeight: "45.1px" }}
            >
              <InputLabel id="demo-simple-select-standard-label">
                Payment Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Payment Type"
                style={{ minHeight: "29.11px" }}
                value={values1.paymentType}
                onChange={handleChange1("paymentType")}
              >
                <MenuItem value="Self-Payment">Self Payment</MenuItem>
                <MenuItem value="Account Payment">Account Payment</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}>
            <MDBox>
              <MDInput
                type="text"
                label="Account Number"
                variant="standard"
                fullWidth
                inputProps={{
                  pattern: "^[0-9]+$",
                  maxLength: 30,
                }}
                disabled={values1.paymentType === "Self-Payment" ? true : false}
                value={values1.accountNumber}
                onChange={handleChange1("accountNumber")}
              />
              {accountErrr ? (
                <span style={errMsg}>Account Number can't be blank</span>
              ) : (
                ""
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={3}></Grid>
          <Grid item xs={12} lg={3}>
            <FormControl variant="standard" fullWidth>
              <InputLabel htmlFor="standard-adornment-password">
                New Password
              </InputLabel>
              <Input
                id="standard-adornment-password"
                type={showNewPassword ? "text" : "password"}
                value={values1.password}
                inputProps={{
                  pattern: "^[A-Za-z0-9]+$",
                  maxLength: 30,
                }}
                onChange={handleChange1("password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      // onClick={setShowNewPassword}
                      // onMouseDown={setShowNewPassword}
                      edge="end"
                    >
                      {showNewPassword ? (
                        <VisibilityOff
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        />
                      ) : (
                        <Visibility
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
              {passwordErr !== "" ? (
                <span style={errMsg}>{passwordErr}</span>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}>
            <FormControl variant="standard" fullWidth>
              <InputLabel htmlFor="standard-adornment-password">
                Confirm Password
              </InputLabel>
              <Input
                id="standard-adornment-password"
                type={showConfirmPassword ? "text" : "password"}
                value={values1.confirmPassword}
                onChange={handleChange1("confirmPassword")}
                inputProps={{
                  pattern: "^[A-Za-z0-9]+$",
                  maxLength: 30,
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      // onClick={setShowNewPassword}
                      // onMouseDown={setShowNewPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        />
                      ) : (
                        <Visibility
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
              {confirmPasswordErr !== "" ? (
                <span style={errMsg}>{confirmPasswordErr}</span>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}></Grid>

          <Grid
            item
            xs={12}
            lg={12}
            textAlign={"center"}
            style={{ marginTop: "-9px" }}
          >
            <Checkbox
              className="checked"
              onChange={() => setChecked(checked === false ? true : false)}
              sx={{
                borderColor: "pink",
                "&.Mui-checked": {
                  borderColor: "pink",
                },
              }}
            />
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "default", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;By registering you accept our&nbsp;
            </MDTypography>
            <MDTypography
              component="a"
              href="https://edios.global/our-solutions/"
              variant="button"
              fontWeight="bold"
              color="info"
              onClick={saveSignupData}
              textGradient
            >
              Terms and Conditions&nbsp;&nbsp;
            </MDTypography>
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "default", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;and our&nbsp;
            </MDTypography>
            <MDTypography
              component="a"
              href="https://edios.global/our-solutions/"
              variant="button"
              fontWeight="bold"
              color="info"
              onClick={saveSignupData}
              textGradient
            >
              Privacy Policy.
            </MDTypography>
          </Grid>

          {/* <Grid item xs={12} lg={12} textAlign={"center"} >

            <Checkbox onChange={() => setChecked(checked === false ? true : false)} />
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;By registering you accept our&nbsp;
            </MDTypography>
            <MDTypography
              component="a"
              href="#"
              variant="button"
              fontWeight="bold"
              color="info"
              textGradient
            >
              Terms and Conditions&nbsp;&nbsp;
            </MDTypography>
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;and our&nbsp;
            </MDTypography>
            <MDTypography
              component="a"
              href="#"
              variant="button"
              fontWeight="bold"
              color="info"
              textGradient
            >
              Privacy Policy.
            </MDTypography>

          </Grid> */}
        </Grid>
        {/* <Grid container style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={4}>
            <MDBox >
              <MDButton variant="gradient" color="info" fullWidth onClick={signup}>
                Get Started
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
        <MDBox pt={3} pb={4} textAlign="center">
          <MDTypography variant="button" color="text">
            Already have an account?{" "}
            <MDTypography
              component={Link}
              to="/customerLogin"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Login
            </MDTypography>
          </MDTypography>
        </MDBox> */}
        <Grid
          container
          style={{ display: "flex", justifyContent: "center" }}
          pt={3}
        >
          <Grid item xs={4}>
            <MDBox mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={signup}
              >
                Get Started
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={2.1} mb={1} textAlign="center">
          <MDTypography variant="button" color="text">
            Already have an account?{" "}
            <MDTypography
              component={Link}
              to="/customerLogin"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Login
            </MDTypography>
          </MDTypography>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default SignUpCover;
